import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPenFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M31.707 12.293L27.707 8.29297C27.5195 8.1055 27.2652 8.00018 27 8.00018C26.7348 8.00018 26.4805 8.1055 26.293 8.29297L23.5 11.086L28.914 16.5L31.707 13.707C31.8945 13.5194 31.9998 13.2651 31.9998 13C31.9998 12.7348 31.8945 12.4805 31.707 12.293Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.086 12.5L12.293 22.293C12.1834 22.4028 12.1009 22.5367 12.052 22.684L10.052 28.684C10.0019 28.8342 9.98829 28.9942 10.0122 29.1508C10.036 29.3073 10.0968 29.456 10.1893 29.5845C10.2819 29.713 10.4037 29.8176 10.5446 29.8899C10.6855 29.9621 10.8416 29.9998 11 30C11.1074 30 11.2142 29.9824 11.316 29.948L17.316 27.948C17.4632 27.8991 17.5971 27.8166 17.707 27.707L27.5 17.914L22.086 12.5Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPenFilled);
export default ForwardRef;
